import { useEffect, useState } from 'react';

const BRAND_NAME = 'FamaPOS';
const COMPANY_NAME = 'Espaço Saúde';

export default function useFamaBranding() {
  const [logoUrl, setLogoUrl] = useState('');

  useEffect(() => {
    let alive = true;

    const applyBrowserBranding = (logo) => {
      document.title = BRAND_NAME;

      let icon = document.querySelector("link[rel='icon']");
      if (!icon) {
        icon = document.createElement('link');
        icon.setAttribute('rel', 'icon');
        document.head.appendChild(icon);
      }

      if (logo) {
        icon.setAttribute('href', logo);
      }
    };

    applyBrowserBranding('');

    const base =
      process.env.REACT_APP_BACKEND_URL ||
      'https://parafar-backend-1060410336578.europe-west1.run.app';

    fetch(`${base}/api/public/branding`)
      .then(async (res) => {
        if (!res.ok) {
          throw new Error(`HTTP ${res.status}`);
        }
        return await res.json();
      })
      .then((data) => {
        if (!alive) return;
        const logo = String(data?.company_logo_url || '').trim();
        setLogoUrl(logo);
        applyBrowserBranding(logo);
      })
      .catch(() => {
        if (!alive) return;
        setLogoUrl('');
        applyBrowserBranding('');
      });

    return () => {
      alive = false;
    };
  }, []);

  return {
    brandName: BRAND_NAME,
    companyName: COMPANY_NAME,
    logoUrl,
  };
}
